import styled from '@emotion/styled';
import { ToastVariant } from './toast.types';
import { Typography } from '@design-system/atoms/typography/Typography';

export const ToastContainer = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000000;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 400px;
`;

export const Toast = styled.section`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  border-radius: 8px;
  width: 368px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background-color: ${({ theme }) => theme.colors.technical['adaptive-reverse']};
  animation: slideIn 0.3s ease;

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(100%);
      opacity: 0;
    }
  }

  &.closing {
    animation: slideOut 0.3s ease forwards;
  }
`;

export const ToastTitle = styled(Typography)<{ $taostVariant: ToastVariant }>`
  font-weight: 600;

  ${({ $taostVariant, theme }) => {
    const variantStyles = {
      info: {
        color: theme.colors.status.info.normal,
      },
      success: {
        color: theme.colors.primary.normal,
      },
      warning: {
        color: theme.colors.status.warning.normal,
      },
      error: {
        color: theme.colors.status.error.normal,
      },
    };

    return variantStyles[$taostVariant];
  }}
`;

export const ToastHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

export const ToastContent = styled.div`
  margin-right: 8px;
  color: ${({ theme }) => theme.colors.technical.gray[60]};
`;
